/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./prueba.component.css.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./prueba.component";
var styles_PruebaComponent = [i0.styles];
var RenderType_PruebaComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_PruebaComponent, data: {} });
export { RenderType_PruebaComponent as RenderType_PruebaComponent };
export function View_PruebaComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "div", [], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, [" probbando\n"]))], null, null); }
export function View_PruebaComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "page-prueba", [], null, null, null, View_PruebaComponent_0, RenderType_PruebaComponent)), i1.ɵdid(1, 49152, null, 0, i2.PruebaComponent, [], null, null)], null, null); }
var PruebaComponentNgFactory = i1.ɵccf("page-prueba", i2.PruebaComponent, View_PruebaComponent_Host_0, {}, {}, []);
export { PruebaComponentNgFactory as PruebaComponentNgFactory };
